<template>
<div class="chapter">
<div class="inner_page">
<div class="image_container">
<a id="page_iv"></a><img alt="Image" src="images/logo2.jpg"/>
</div>
<p class="copyt"><em class="italic">Breaking the German Dams</em></p>
<p class="copy">First published in 2023 by</p>
<p class="copy">Greenhill Books,</p>
<p class="copy">c/o Pen &amp; Sword Books Ltd,</p>
<p class="copy">George House, Unit 12 &amp; 13,</p>
<p class="copy">Beevor Street, Off Pontefract Road,</p>
<p class="copy">Barnsley, South Yorkshire S71 1HN</p>
<p class="copy1"><span class="weblink"><a href="http://www.greenhillbooks.com" target="_blank"><span class="underline">www.greenhillbooks.com</span></a></span></p>
<p class="copy"><span class="weblink"><a href="mailto:contact@greenhillbooks.com"><span class="underline">contact@greenhillbooks.com</span></a></span></p>
<p class="copy1">ISBN: 978–1–78438–962–8</p>
<p class="copy">EPUB ISBN: 978–1–78438–963–5</p>
<p class="copy">MOBI ISBN: 978–1–78438–963–5</p>
<p class="copy1">All rights reserved.</p>
<p class="copy1">© Robert Owen, 2023</p>
<p class="copy1">The right of Robert Owen to be identified as author of this work have been asserted in accordance with Section 77 of the Copyrights, Designs and Patents Act 1988.</p>
<p class="copy1">CIP data records for this title are available from the British Library</p>
<p class="copy1">Edited and designed by Donald Sommerville</p>
<p class="copy">Maps by Peter Wilkinson</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Copyright.vue?027fb559